// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-443e331f]{padding:80px 60px 0 60px;text-align:center}h3[data-v-443e331f]{color:#ffba69;padding-left:9px}.container input[data-v-443e331f]{width:99%;color:#333;height:35px;border:1px solid #000;margin-top:20px;font-size:16px}.init-userinfo[data-v-443e331f]{display:flex;flex-direction:column;align-items:center}.init-userinfo-avatar[data-v-443e331f]{width:64px;height:64px;margin:10px}", ""]);
// Exports
module.exports = exports;
